import type { VideoCategory, VideoCategoryShallow } from "@brookbush/types";

import type { GetStaticPaths, GetStaticProps } from "next";

import { VideosCatalogue, VideosCategory } from "../components";
import { GridLayout } from "~/layouts";
import { getCategoryPathByCategory } from "~/lib/videos.lib";
import type { NextPageWithProps } from "~/types";
import fetcher from "~/utils/fetcher.client";

interface VideosCategoryPageProps {
	shallowCategories: VideoCategoryShallow[];
	category: VideoCategory;
}

const VideosCategoryPage: NextPageWithProps<VideosCategoryPageProps> = ({
	category,
	shallowCategories,
}) => {
	return (
		<>
			<GridLayout.Sidebar className="z-20 laptop:block hidden">
				<VideosCatalogue shallowCategories={shallowCategories} />
			</GridLayout.Sidebar>

			<GridLayout.Body>
				<VideosCategory
					category={category}
					shallowCategories={shallowCategories}
				/>
			</GridLayout.Body>
		</>
	);
};

VideosCategoryPage.Layout = GridLayout;

export const getStaticPaths: GetStaticPaths = () => {
	return {
		paths: [],
		fallback: "blocking",
	};
};

export const getStaticProps: GetStaticProps<
	any,
	{
		slugs: string[];
	}
> = async ({ params }) => {
	const [shallowCategories, category] = await Promise.all([
		fetcher("/videos/categories/shallow"),
		fetcher(`/videos/categories/${params!.slugs.join("/")}`),
	]);

	const videoCategoryPath = getCategoryPathByCategory(
		shallowCategories,
		category,
	)!;

	const breadcrumbs: {
		href: string;
		name: string;
	}[] = [];

	for (let i = 0; i < videoCategoryPath.length; i++) {
		const currentCategory = videoCategoryPath[i];
		breadcrumbs.push({
			name: currentCategory.title,
			href: `/videos/categories/${videoCategoryPath
				.slice(0, i + 1)
				.map((c) => c.slug)
				.join("/")}`,
		});
	}

	breadcrumbs.unshift({
		name: "Categories",
		href: "/videos",
	});

	breadcrumbs.unshift({
		name: "Videos",
		href: "/videos",
	});

	return {
		props: {
			shallowCategories,
			category,
			breadcrumbs,
		},
	};
};

export default VideosCategoryPage;
